'use client';

import { FaqCardFragment } from '@/__generated__/graphql';
import { FAQ_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useFragment } from '@apollo/client';

import FaqCard from '../FaqCard';

export default function FaqResult({ id }: { id: string }) {
  const { data } = useFragment({
    fragment: FAQ_CARD_FRAGMENT,
    fragmentName: 'faqCard',
    from: { id, __typename: 'faq_Entry' },
  });

  return <FaqCard {...(data as FaqCardFragment)} />;
}
